<div class="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start w-full">
  <!-- Left column skeleton -->
  <div class="lg:col-span-8 flex flex-col gap-6">
    <!-- Status Header skeleton -->
    <div
      class="bg-white dark:bg-gray-2 border border-gray-3 rounded-2xl p-4 flex items-center justify-between"
    >
      <ngx-skeleton-loader
        [theme]="{ width: '140px', height: '28px', 'border-radius': '9999px', margin: '0' }"
        animation="pulse"
      />
      <ngx-skeleton-loader
        [theme]="{ width: '100px', height: '24px', 'border-radius': '9999px', margin: '0' }"
        animation="pulse"
      />
    </div>

    <!-- Photos card skeleton -->
    <div class="bg-white dark:bg-gray-2 border border-gray-3 rounded-3xl p-6 flex flex-col gap-4">
      <ngx-skeleton-loader
        [theme]="{ width: '100%', height: '280px', 'border-radius': '1.25rem', margin: '0' }"
        animation="pulse"
      />
      <div class="grid grid-cols-4 gap-3">
        @for (i of [1, 2, 3, 4]; track i) {
          <ngx-skeleton-loader
            [theme]="{ width: '100%', height: '70px', 'border-radius': '0.75rem', margin: '0' }"
            animation="pulse"
          />
        }
      </div>
    </div>

    <!-- Presentation card skeleton -->
    <div class="bg-white dark:bg-gray-2 border border-gray-3 rounded-3xl p-6 flex flex-col gap-4">
      <ngx-skeleton-loader
        [theme]="{ width: '60%', height: '28px', 'border-radius': '6px', margin: '0' }"
        animation="pulse"
      />
      <ngx-skeleton-loader
        [theme]="{ width: '100%', height: '16px', 'border-radius': '4px', margin: '0' }"
        animation="pulse"
      />
      <ngx-skeleton-loader
        [theme]="{ width: '90%', height: '16px', 'border-radius': '4px', margin: '0' }"
        animation="pulse"
      />
      <ngx-skeleton-loader
        [theme]="{ width: '75%', height: '16px', 'border-radius': '4px', margin: '0' }"
        animation="pulse"
      />
    </div>

    <!-- Key Info skeleton -->
    <div class="bg-white dark:bg-gray-2 border border-gray-3 rounded-3xl p-6">
      <div class="grid grid-cols-2 sm:grid-cols-4 gap-4">
        @for (i of [1, 2, 3, 4]; track i) {
          <div class="p-3 bg-gray-1 dark:bg-gray-3/30 rounded-2xl flex flex-col gap-2">
            <ngx-skeleton-loader
              [theme]="{ width: '50px', height: '12px', 'border-radius': '4px', margin: '0' }"
              animation="pulse"
            />
            <ngx-skeleton-loader
              [theme]="{ width: '80px', height: '20px', 'border-radius': '6px', margin: '0' }"
              animation="pulse"
            />
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Right column skeleton (Sidebar) -->
  <div class="lg:col-span-4 sticky top-6 flex flex-col gap-6">
    <div class="bg-white dark:bg-gray-2 border border-gray-3 rounded-3xl p-6 flex flex-col gap-4 shadow-sm">
      <ngx-skeleton-loader
        [theme]="{ width: '65%', height: '26px', 'border-radius': '6px', margin: '0' }"
        animation="pulse"
      />
      <ngx-skeleton-loader
        [theme]="{ width: '100%', height: '36px', 'border-radius': '8px', margin: '0' }"
        animation="pulse"
      />
      <div class="p-4 bg-gray-1 dark:bg-gray-3/20 rounded-2xl flex flex-col gap-2.5">
        <div class="flex justify-between">
          <ngx-skeleton-loader
            [theme]="{ width: '120px', height: '14px', 'border-radius': '4px', margin: '0' }"
            animation="pulse"
          />
          <ngx-skeleton-loader
            [theme]="{ width: '40px', height: '14px', 'border-radius': '4px', margin: '0' }"
            animation="pulse"
          />
        </div>
        <ngx-skeleton-loader
          [theme]="{ width: '100%', height: '10px', 'border-radius': '9999px', margin: '0' }"
          animation="pulse"
        />
      </div>
      <div class="py-3 border-y border-gray-3 flex flex-col gap-3">
        <div class="flex justify-between items-center">
          <ngx-skeleton-loader
            [theme]="{ width: '80px', height: '14px', 'border-radius': '4px', margin: '0' }"
            animation="pulse"
          />
          <ngx-skeleton-loader
            [theme]="{ width: '100px', height: '20px', 'border-radius': '6px', margin: '0' }"
            animation="pulse"
          />
        </div>
        <div class="flex justify-between items-center">
          <ngx-skeleton-loader
            [theme]="{ width: '70px', height: '14px', 'border-radius': '4px', margin: '0' }"
            animation="pulse"
          />
          <ngx-skeleton-loader
            [theme]="{ width: '50px', height: '20px', 'border-radius': '6px', margin: '0' }"
            animation="pulse"
          />
        </div>
      </div>
      <ngx-skeleton-loader
        [theme]="{ width: '100%', height: '52px', 'border-radius': '1rem', margin: '0' }"
        animation="pulse"
      />
    </div>
  </div>
</div>
